<template>
    <div class="container">
        <HomeHeader />
        <ReportHeader>
            <div class="show_date">
                <ShowYear :year="year" />
                <ShowMonth :months="[month]" style="margin-left: 57px" />
            </div>
        </ReportHeader>
        <BgContainer>
            <main>
                <div class="title_row">
                    <PageTitle title="个人主页" :isBack="true" to="/" />
                </div>
                <div class="content">
                    <div class="form">
                        <div class="form_row">
                            <span class="label">用户名：</span>
                            <span class="value" v-if="!isEdit">{{ form.userName }}</span>
                            <el-input v-else placeholder="请输入" maxlength="32" v-model.trim="form.userName"></el-input>
                        </div>
                        <div class="form_row">
                            <span class="label">部门：</span>
                            <span class="value" v-if="!isEdit">{{ form.department || "-" }}</span>
                            <el-input v-else placeholder="请输入" maxlength="32" v-model.trim="form.department"></el-input>
                        </div>
                        <div class="form_row">
                            <span class="label">邮箱：</span>
                            <span class="value">{{ form.loginName }}</span>
                            <!-- <el-input v-else placeholder="请输入" disabled :model-value="form.loginName"></el-input> -->
                        </div>
                        <div class="form_row">
                            <span class="label">注册时间：</span>
                            <span class="value">{{ form.registerTime }}</span>
                        </div>
                    </div>
                    <div class="btn_box">
                        <el-button type="primary" v-if="!isEdit" @click="isEdit = true">编&nbsp;&nbsp;辑</el-button>
                        <el-button type="primary" v-if="isEdit" :loading="loading" @click="handleSave">保&nbsp;&nbsp;存</el-button>
                        <el-button type="primary" v-if="!isEdit" @click="openPass">修改密码</el-button>
                    </div>
                </div>
            </main>
        </BgContainer>
    </div>
    <!-- 修改密码 -->
    <PasswordDialog :show="showPass" :user="form" @close="closePass" />
</template>

<script setup>
import BgContainer from "@/components/customer-week-report/pc/BgContainer.vue";
import ReportHeader from "@/components/customer-week-report/pc/ReportHeader.vue";
import PageTitle from "@/components/customer-week-report/pc/PageTitle.vue";
import ShowYear from "@/components/customer-week-report/pc/ShowYear.vue";
import ShowMonth from "@/components/customer-week-report/pc/ShowMonth.vue";
import HomeHeader from "@/components/common/HomeHeader.vue";
import useUser from "./useUser";
import PasswordDialog from "./password-dialog/index.vue";
import usePassword from "./password-dialog/usePassword";

const year = new Date().getFullYear();
const month = new Date().getMonth() + 1;

// 用户信息
const { isEdit, form, loading, handleSave } = useUser();

// 修改密码
const { show: showPass, open: openPass, close: closePass } = usePassword();
</script>

<style lang="scss" scoped>
.container {
    background-color: #e6e6e6;
    min-height: calc(100vh - var(--home-header-height));
    padding-top: var(--home-header-height);

    .show_date {
        border-top: 1px solid var(--week-primary-color);
        position: absolute;
        top: 60px;
        right: 44px;
        padding-top: 30px;
        padding-right: 100px;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }

    .small_logo {
        position: absolute;
        top: 87px;
        right: 52px;
    }

    main {
        width: 100%;
        min-height: calc(100vh - var(--week-pc-header-height));
        background-color: #f5f5f5;
        box-shadow: 0 0 20px #ccc;
        padding: 46px 80px;

        .title_row {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .content {
            background-color: #ffffff;
            box-shadow: 0px 8px 10px 3px rgba(0, 0, 0, 0.07);
            margin-top: 24px;
            padding: 48px;
            .form {
                .form_row {
                    height: 32px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 12px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .label {
                        display: block;
                        width: 96px;
                        color: #727272;
                        font-size: 14px;
                    }
                    .value {
                        font-size: 14px;
                        color: #000;
                    }
                    .el-input {
                        width: 240px;
                        height: 32px;
                        :deep(.el-input__inner) {
                            border-radius: 2px;
                        }
                    }
                }
            }
            .btn_box {
                margin-top: 32px;
                .el-button {
                    height: 48px;
                    width: 160px;
                    margin-right: 38px;
                    border-radius: 2px;
                    :deep(span) {
                        font-size: 16px;
                    }
                }
            }
        }
    }
}
</style>
